/**
 * CJdropshipping vs Dayone 子页面 — 服务端数据获取
 * 路由：/cjdropshipping-vs-day-one-fulfillment
 *
 * 【注意】纯展示页面，无需调用后端 API，仅返回 SEO 信息和 CDN 配置。
 * SEO 内容为 Dayone 专属。
 *
 * @param {Object} ctx - SSR 直传 Koa ctx 或 ssrDataLoader 统一上下文
 * @returns {Object} 包含 __seo 和 cdnHost 字段
 */
async function fetchData(ctx) {
  let cdnHost = '';
  const eggCtx = (ctx && ctx.app) ? ctx : (ctx && ctx.ctx);
  if (eggCtx && eggCtx.app && eggCtx.app.config) {
    const viewVar = eggCtx.app.config.view && eggCtx.app.config.view.variable;
    cdnHost = (viewVar && viewVar.CDN_HOST) || '';
  }
  if (!cdnHost && typeof CDN_HOST !== 'undefined') {
    cdnHost = CDN_HOST;
  }
  return {
    cdnHost,
    __seo: {
      title: 'CJdropshipping vs Day One Fulfillment - Day One Fulfillment Alternatives Comparison',
      keywords:
        'CJdropshipping vs Day One Fulfillment, Day One Fulfillment alternatives, ecommerce fulfillment services',
      description:
        'Compare CJdropshipping and Day One Fulfillment for ecommerce fulfillment, warehousing, shipping solutions, automation, and scalable dropshipping services.',
    },
  };
}

module.exports = fetchData;
